import React, { useState } from "react";
import { SearchOutlined } from "@ant-design/icons";
import DateRangeField from "../../CoreComponents/DateRangeField";

export default function PaymentsRangeFilter({ applied, loading, onSearch }) {
  const [draft, setDraft] = useState(applied);

  const allTime = () => {
    setDraft(null);
    onSearch(null);
  };

  return (
    <div className="stl-toolbar__group">
      <div className="stl-field">
        <span className="stl-field__label">Paid between</span>
        <DateRangeField label="Paid between" value={draft} onChange={setDraft} />
      </div>
      <button type="button" className="stl-btn stl-btn--primary" disabled={loading} onClick={() => onSearch(draft)}>
        <SearchOutlined /> Search
      </button>
      {applied && (
        <button type="button" className="stl-link-btn" onClick={allTime}>
          All time
        </button>
      )}
    </div>
  );
}
